import FileIcon from 'components/Icons/File';
import Folder from 'components/Icons/Folder';
import Studio from 'components/Icons/Studio';
import { StdListCell, StdListCheckbox, StdListRow } from 'components/StdList';
import moment from 'moment';
import React from 'react';
import { StudioProject } from 'records/StudioProject';
import { StudioProjectFileData } from 'records/StudioProjectFile';
import { StudioProjectFolderData } from 'records/StudioProjectFolder';

interface Props {
  checked: boolean;
  item: {
    value: StudioProject | StudioProjectFileData | StudioProjectFolderData;
    type: string;
  };
  onClick: () => void;
  onChecked: () => void;
}

const StudioFolderListRow: React.FC<Props> = (props: Props) => {
  const { checked, item, onClick, onChecked } = props;
  const itemId = item.value.id.toString();

  const rowId = `studio-folder-list-row-${item.value.id}`;

  const isFile = item.type === 'file';

  const createIcon = () => {
    switch (item.type) {
      case 'project':
        return <Studio width="18px" height="18px" />;
      case 'folder':
        return <Folder />;
      default:
        return <FileIcon />;
    }
  };
  const style: any = {
    display: 'flex',
    alignItems: 'center',
    fontWeight: item.type === 'folder' ? 'bold' : 'normal',
    opacity: isFile ? 0.25 : 1,
  };

  return (
    <StdListRow id={itemId} onClick={onClick} selected={checked}>
      {isFile ? (
        <StdListCell id={`${rowId}-cell-name`}> </StdListCell>
      ) : (
        <StdListCheckbox
          rowId={itemId}
          disabled={item.type === 'file'}
          indeterminate={false}
          onChange={onChecked}
          checked={checked}
        />
      )}
      <StdListCell id={`${rowId}-cell-name`} style={style}>
        <div className="mr2">{createIcon()}</div>
        {item.value.name}
      </StdListCell>
      <StdListCell
        id={`${rowId}-cell-date`}
        style={{ paddingLeft: '2.625rem', opacity: isFile ? 0.25 : 1 }}
      >
        {item.type === 'folder' ||
          (item.type === 'file' &&
            moment(item.value.created).format('ll').toString())}
      </StdListCell>
    </StdListRow>
  );
};
export default StudioFolderListRow;
